const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const addSuffix = (day) => {
  // Returns day with suffix
  // Example: day = 22, "i" is 2 and "j" is 22, the output will be 22nd
  // Example: day = 12, "i" is 2 and "j" is 12, the output will be 12th
  // Example: day = 1, "i"  is 1 and "j" is 1, the output will be 1st
  const i = day % 10;
  const j = day % 100;

  if (j === 1 && j !== 11) {
    return `${i}st`;
  }
  if (j === 2 && j !== 12) {
    return `${i}nd`;
  }
  if (j === 3 && j !== 13) {
    return `${i}rd`;
  }
  return `${j}th`;
};

// Returns date format April 8th 2022, 10:14 am
const getFormattedDate = (date) => {
  const day = date.getDate();
  const time = date
    .toLocaleString([], { hour: "numeric", minute: "numeric", hour12: true })
    .toLowerCase();
  const month = date.getMonth();
  const year = date.getFullYear();

  return `${MONTHS[month]} ${addSuffix(day)} ${year}, ${time}`;
};

export default getFormattedDate;
